import React from 'react';

import { Icon, Button } from '..';


export const SearchButton = ({ onClick, vendorClass, id }) => (
  <Button
    additions={ [ 'primary', 'largeCircle' ] }
    vendorClass={ vendorClass }
    onClick={ onClick }
    data-testid={ id }
  >
    <Icon
      svg="SEARCH"
      svgProps={{ width: '28', height: '28' }}
    />
  </Button>
);
